export const currencyLocaleMap = {
  'en-US': 'USD',
  'en-GB': 'GBP',
  'en-AU': 'AUD',
  'en-CA': 'CAD',
  'en-NZ': 'NZD',
  'en-ZA': 'ZAR',
  'en-IE': 'EUR',
  'en-SG': 'SGD',
  'en-HK': 'HKD',
  'en-IN': 'INR',
  'en-PH': 'PHP',
  'en-MY': 'MYR',
  'en-NG': 'NGN',
  'en-KE': 'KES',
  'en-GH': 'GHS',
  'en-PK': 'PKR',
  'en-BD': 'BDT',
  'en-AE': 'AED',
  'en-SA': 'SAR',
  'en-QA': 'QAR',
  'en-BH': 'BHD',
  'en-OM': 'OMR',
  'en-JM': 'JMD',
  'en-TT': 'TTD',
  'en-BB': 'BBD',
  'en-BZ': 'BZD',
  'en-AG': 'XCD',
  'en-LC': 'XCD',
  'en-VC': 'XCD',
  'en-DM': 'XCD',
  'en-GD': 'XCD',
  'en-KN': 'XCD',
  'en-AT': 'EUR',
  'en-BE': 'EUR',
  'en-BG': 'BGN',
  'en-CY': 'EUR',
  'en-CZ': 'CZK',
  'en-DE': 'EUR',
  'en-DK': 'DKK',
  'en-EE': 'EUR',
  'en-ES': 'EUR',
  'en-FI': 'EUR',
  'en-FR': 'EUR',
  'en-GR': 'EUR',
  'en-HR': 'EUR',
  'en-HU': 'HUF',
  'en-IT': 'EUR',
  'en-LT': 'EUR',
  'en-LU': 'EUR',
  'en-LV': 'EUR',
  'en-MT': 'EUR',
  'en-NL': 'EUR',
  'en-PL': 'PLN',
  'en-PT': 'EUR',
  'en-RO': 'RON',
  'en-SE': 'SEK',
  'en-SI': 'EUR',
  'en-SK': 'EUR',
  'en-CH': 'CHF',
  'en-NO': 'NOK',
  'en-IS': 'ISK',
  'en-LI': 'CHF',

  // European languages
  'de-DE': 'EUR',
  'de-AT': 'EUR',
  'de-CH': 'CHF',
  'it-IT': 'EUR',
  'it-CH': 'CHF',
  'pt-BR': 'BRL',
  'pt-PT': 'EUR',
  'nl-NL': 'EUR',
  'nl-BE': 'EUR',
  'sv-SE': 'SEK',
  'da-DK': 'DKK',
  'nb-NO': 'NOK',
  'no-NO': 'NOK',
  'fi-FI': 'EUR',
  'pl-PL': 'PLN',
  'cs-CZ': 'CZK',
  'sk-SK': 'EUR',
  'hu-HU': 'HUF',
  'ro-RO': 'RON',
  'bg-BG': 'BGN',
  'hr-HR': 'EUR',
  'sl-SI': 'EUR',
  'et-EE': 'EUR',
  'lv-LV': 'EUR',
  'lt-LT': 'EUR',
  'ru-RU': 'RUB',
  'uk-UA': 'UAH',
  'el-GR': 'EUR',
  'tr-TR': 'TRY',

  // French variants
  'fr-FR': 'EUR',
  'fr-CA': 'CAD',
  'fr-CH': 'CHF',
  'fr-BE': 'EUR',
  'fr-LU': 'EUR',
  'fr-MC': 'EUR',
  'fr-GP': 'EUR',
  'fr-GF': 'EUR',
  'fr-MQ': 'EUR',
  'fr-RE': 'EUR',
  'fr-YT': 'EUR',
  'fr-MA': 'MAD',
  'fr-DZ': 'DZD',
  'fr-TN': 'TND',
  'fr-HT': 'HTG',
  'fr-KM': 'KMF',
  'fr-BJ': 'XOF',
  'fr-BF': 'XOF',
  'fr-CI': 'XOF',
  'fr-GW': 'XOF',
  'fr-ML': 'XOF',
  'fr-NE': 'XOF',
  'fr-SN': 'XOF',
  'fr-TG': 'XOF',
  'fr-CM': 'XAF',
  'fr-CF': 'XAF',
  'fr-TD': 'XAF',
  'fr-CG': 'XAF',
  'fr-GQ': 'XAF',
  'fr-GA': 'XAF',
  'fr-PF': 'XPF',
  'fr-NC': 'XPF',
  'fr-WF': 'XPF',

  // Spanish variants
  'es-ES': 'EUR',
  'es-MX': 'MXN',
  'es-AR': 'ARS',
  'es-CO': 'COP',
  'es-CL': 'CLP',
  'es-PE': 'PEN',
  'es-BO': 'BOB',
  'es-EC': 'USD',
  'es-UY': 'UYU',
  'es-VE': 'VES',
  'es-CR': 'CRC',
  'es-CU': 'CUP',
  'es-DO': 'DOP',
  'es-SV': 'USD',
  'es-GT': 'GTQ',
  'es-HN': 'HNL',
  'es-NI': 'NIO',
  'es-PR': 'USD',
  'es-PY': 'PYG',

  // Asian languages
  'ja-JP': 'JPY',
  'ko-KR': 'KRW',
  'zh-CN': 'CNY',
  'zh-TW': 'TWD',
  'zh-HK': 'HKD',
  'zh-SG': 'SGD',
  'hi-IN': 'INR',
  'bn-BD': 'BDT',
  'th-TH': 'THB',
  'vi-VN': 'VND',
  'id-ID': 'IDR',
  'ms-MY': 'MYR',
  'tl-PH': 'PHP',
  'ur-PK': 'PKR',
  'fa-IR': 'IRR',
  'ar-SA': 'SAR',
  'ar-AE': 'AED',
  'ar-EG': 'EGP',
  'ar-JO': 'JOD',
  'ar-LB': 'LBP',
  'ar-KW': 'KWD',
  'ar-QA': 'QAR',
  'ar-BH': 'BHD',
  'ar-OM': 'OMR',
  'he-IL': 'ILS',

  // African languages
  'af-ZA': 'ZAR',
  'sw-KE': 'KES',
  'am-ET': 'ETB',
  'ha-NG': 'NGN',
  'yo-NG': 'NGN',
  'ig-NG': 'NGN',
  'ar-DZ': 'DZD',
  'ar-TN': 'TND',
  'ar-LY': 'LYD',
  'ar-MA': 'MAD',

  // Other major currencies
  'is-IS': 'ISK',
  'mt-MT': 'EUR',
  'ga-IE': 'EUR',
  'cy-GB': 'GBP',
  'eu-ES': 'EUR',
  'ca-ES': 'EUR',
  'gl-ES': 'EUR',
  'mk-MK': 'MKD',
  'sq-AL': 'ALL',
  'sr-RS': 'RSD',
  'bs-BA': 'BAM',
  'me-ME': 'EUR',

  // Additional major markets
  'en-MX': 'MXN',
  'es-US': 'USD',
};
